<template>
  <div>
    <cost-centre-menu></cost-centre-menu>

    <v-row style="margin-bottom: 15px">
      <v-col cols="3">
        <v-text-field :label="$t('global.search')" append-icon="search" hide-details single-line v-model="search"></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <div>
        <v-btn
          :disabled="selected.length === 0"
          @click="
            dialog = true;
            selectedCostCentres = null;
          "
          block
          color="accent"
          >{{ $t("global.editSelected") }}
        </v-btn>
      </div>
    </v-row>
    <v-data-table :headers="headers" :items="users" :search="search" show-select v-model="selected">
      <template #item="props">
        <tr>
          <td>
            <v-checkbox hide-details primary @change="props.select" :value="props.isSelected" class="mt-0" />
          </td>
          <td class="text-left">{{ props.item.name }}</td>
          <td class="text-left">{{ props.item.surname }}</td>
          <td class="text-left">{{ props.item.login }}</td>
          <td class="text-left">{{ props.item.email }}</td>
          <td class="text-left">
            {{ props.item.organization_structure }}
          </td>
          <td class="text-left">
            <v-tooltip bottom>
              {{ $t("global.edit") }}
              <template #activator="{on}">
                <v-btn v-on="on" @click="openDialogDirectly(props.item)" icon>
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog max-width="800px" persistent v-model="dialog">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("settings.costCentre.user.dialogTitle") }}</span>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="editedHeaders"
            :items="selected"
            hide-default-footer
            :footer-props="{ 'items-per-page-options': [{ text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }] }"
          >
            <template #item="props">
              <tr>
                <td class="text-left">{{ props.item.name }} {{ props.item.surname }}</td>
                <td class="text-left">{{ props.item.login }}</td>
                <td class="text-left">{{ props.item.email }}</td>
              </tr>
            </template>
          </v-data-table>
          <v-select
            :items="enabledCostCentres"
            chips
            clearable
            item-text="name"
            item-value="id"
            :label="$t('settings.costCentre.user.allowedCostCentres')"
            multiple
            v-model="selectedCostCentres"
          >
          </v-select>
          <v-select
            :items="availableDefaultCostCentre"
            clearable
            item-text="name"
            item-value="id"
            :label="$t('settings.costCentre.user.defaultCostCentre')"
            v-model="defaultCostCentre"
          >
          </v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="dialog = false" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
          <v-btn :disabled="$store.getters['Ajax/loading']" @click="save" color="blue darken-1" text>{{ $t("global.save") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CostCentreMenu from "../../../components/Settings/CostCentre/CostCentreMenu";

export default {
  name: "SettingsCostCentreUsersView",
  components: { CostCentreMenu },
  data: () => ({
    selected: [],
    selectedCostCentres: [],
    defaultCostCentre: null,
    users: [],
    search: "",
    dialog: null,
    organizationStructureList: [],
    costCentres: []
  }),
  computed: {
    availableDefaultCostCentre() {
      return this.costCentres.filter(v => v.is_enabled === 1 && this.selectedCostCentres != null && this.selectedCostCentres.indexOf(v.id) !== -1);
    },
    enabledCostCentres() {
      return this.costCentres.filter(v => v.is_enabled === 1);
    },
    headers() {
      return [
        { text: this.$t("settings.users.fields.name.name"), value: "name" },
        {
          text: this.$t("settings.users.fields.surname.name"),
          value: "surname"
        },
        { text: this.$t("settings.users.fields.login.name"), value: "login" },
        { text: this.$t("settings.users.fields.email.name"), value: "email" },
        {
          text: this.$t("settings.users.fields.organizationStructure.name"),
          value: "organization_structure"
        },
        { text: this.$t("global.actions"), value: "actions", sortable: false }
      ];
    },
    editedHeaders() {
      return [
        {
          text: this.$t("settings.users.fields.name.name") + " " + this.$t("settings.users.fields.surname.name"),
          value: "surname"
        },
        { text: this.$t("settings.users.fields.login.name"), value: "login" },
        { text: this.$t("settings.users.fields.email.name"), value: "email" }
      ];
    },
    items() {
      return this.getChilds();
    }
  },
  methods: {
    openDialogDirectly(item) {
      this.selected = [item];
      this.dialog = true;
      this.selectedCostCentres = [];
      for (let costcentree of item.costCentre) {
        this.selectedCostCentres.push(costcentree.id);
      }
      this.defaultCostCentre = item.default_cost_centre != null ? item.default_cost_centre.id : null;
    },
    downloadCostCentre() {
      this.axios.get("settings/cost-centre/list").then(response => {
        this.costCentres = response.data;
      });
    },
    edit() {
      this.dialog = true;
    },
    downloadUsers() {
      this.axios.get("settings/cost-centre/users").then(resp => {
        this.users = resp.data;
        this.unselectAllUsers();
      });
    },
    unselectAllUsers() {
      for (let userIndex in this.users) {
        this.users[userIndex].selected = false;
      }
    },
    save() {
      let selectedUserId = [];
      for (let user of this.selected) {
        selectedUserId.push(user.id);
      }
      this.axios
        .post("settings/cost-centre/save-users", {
          users: selectedUserId,
          defaultCostCentre: this.defaultCostCentre,
          costCentres: this.selectedCostCentres
        })
        .then(() => {
          this.downloadUsers();
          this.dialog = false;
          this.$store.dispatch("snackbarPush", {
            text: this.$t("global.saved"),
            position: "down"
          });
        })
        .catch(() => {
          //TODO OBSLUGA BLEDOW
        });
    }
  },
  created() {
    this.downloadCostCentre();
    this.downloadUsers();
  }
};
</script>

<style scoped></style>
